/**
 * Created by Marvin on 17.04.17.
 */
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { AppError } from '@wikom/wikom-data';
var PageHeader = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    if (props.children) {
        return (React.createElement("div", { className: "content-header" },
            React.createElement(AppError, null),
            React.createElement("div", { className: "row" },
                React.createElement("div", { className: "col-md-8" },
                    React.createElement("h2", null, title)),
                React.createElement("div", { className: "col-md-4 text-right content-header-buttons" }, props.children))));
    }
    return (React.createElement("div", { className: "content-header" },
        React.createElement(AppError, null),
        React.createElement("div", { className: "row" },
            React.createElement("div", { className: "col-md-12" },
                React.createElement("h2", null, title)))));
};
export default PageHeader;
